export const DOCUMENT_TEMPLATE_CATEGORIES = {
  UNCATEGORIZED: 'Uncategorized',
  JOB_DESCRIPTIONS: 'Job Descriptions',
  PERFORMANCE_EVALUATIONS: 'Performance Evaluations',
} as const;

export const DOCUMENT_TEMPLATE_CATEGORY_OPTIONS = [
  { label: DOCUMENT_TEMPLATE_CATEGORIES.UNCATEGORIZED, value: DOCUMENT_TEMPLATE_CATEGORIES.UNCATEGORIZED },
  { label: DOCUMENT_TEMPLATE_CATEGORIES.JOB_DESCRIPTIONS, value: DOCUMENT_TEMPLATE_CATEGORIES.JOB_DESCRIPTIONS },
  { label: DOCUMENT_TEMPLATE_CATEGORIES.PERFORMANCE_EVALUATIONS, value: DOCUMENT_TEMPLATE_CATEGORIES.PERFORMANCE_EVALUATIONS },
];

export type DocumentTemplateCategory = typeof DOCUMENT_TEMPLATE_CATEGORIES[keyof typeof DOCUMENT_TEMPLATE_CATEGORIES];
